import { Link } from 'react-router-dom';
import { IconX, IconPlus, IconMinus, IconShoppingBag, IconLock } from '@tabler/icons-react';
import { useCart } from '../../context/CartContext';
import { useProducts } from '../../context/ProductsContext';
import './CartDrawer.css';

export default function CartDrawer() {
  var cart = useCart();
  var productsCtx = useProducts();
  var items = cart.items;
  var itemCount = cart.itemCount;
  var subtotal = cart.subtotal;
  var updateQuantity = cart.updateQuantity;
  var removeItem = cart.removeItem;
  var drawerOpen = cart.drawerOpen;
  var closeDrawer = cart.closeDrawer;

  if (!drawerOpen) return null;

  return (
    <>
      <div className="cart-overlay" onClick={closeDrawer} />
      <div className="cart-drawer">
        <div className="cart-header">
          <h2 className="cart-title">
            <IconShoppingBag size={16} /> Your bag
            {itemCount > 0 && <span className="cart-count"> ({itemCount})</span>}
          </h2>
          <button className="cart-close" onClick={closeDrawer}>
            <IconX size={18} />
          </button>
        </div>

        {items.length === 0 ? (
          <div className="cart-empty">
            <div className="cart-empty__icon"><IconShoppingBag size={28} /></div>
            <h3>Nothing here yet</h3>
            <p>Your bag is empty. When you find something you like, it will appear here.</p>
            <Link to="/shop" className="cart-empty__btn" onClick={closeDrawer}>
              Browse the collection
            </Link>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {items.map(function(item) {
                var thumbProduct = productsCtx.getProductById ? productsCtx.getProductById(item.productId) : null;
                var thumb = thumbProduct && thumbProduct.images ? thumbProduct.images[0] : null;
                return (
                  <div className="cart-item" key={item.key}>
                    <div className="cart-item__img">
                      {thumb ? <img src={thumb} alt={item.name} /> : <IconShoppingBag size={18} />}
                    </div>
                    <div className="cart-item__info">
                      <Link to={'/product/' + item.slug} className="cart-item__name" onClick={closeDrawer}>
                        {item.name}
                      </Link>
                      <div className="cart-item__variant">
                        {item.variantName}{item.variantName && item.colourName ? ' \u00b7 ' : ''}{item.colourName}
                      </div>
                      <div className="cart-item__price">{'$' + item.price}</div>
                      <div className="cart-item__actions">
                        <div className="cart-qty">
                          <button onClick={function() { updateQuantity(item.key, item.quantity - 1); }}>
                            <IconMinus size={12} />
                          </button>
                          <span>{item.quantity}</span>
                          <button onClick={function() { updateQuantity(item.key, item.quantity + 1); }}>
                            <IconPlus size={12} />
                          </button>
                        </div>
                        <button className="cart-item__remove" onClick={function() { removeItem(item.key); }}>
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="cart-footer">
              <div className="cart-subtotal">
                <span>Subtotal</span>
                <span className="cart-subtotal__amount">{'$' + subtotal.toFixed(2)}</span>
              </div>
              <div className="cart-shipping-note">Shipping calculated at checkout</div>
              <Link to="/checkout" className="cart-checkout-btn" onClick={closeDrawer}>
                <IconLock size={13} /> {'Checkout \u2014 $' + subtotal.toFixed(2)}
              </Link>
              <button className="cart-continue-btn" onClick={closeDrawer}>
                Continue shopping
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}